import { START_PAGE_PREFERENCE } from '@constants/userPreferences.ts';
import { ROUTES } from '@router/constants.ts';

const REGISTRATION_USER_EMAIL_KEY = 'registrationUserEmail';
const CLIENT_KEY = 'client';
export const ACCESS_TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const REFRESH_TOKEN_EXPIRES_AT_KEY = 'refreshTokenExpiresAtUTC';

export const persistRefreshTokenExpiresAtUTC = (expiresAtUTC: string): void => {
    localStorage.setItem(REFRESH_TOKEN_EXPIRES_AT_KEY, expiresAtUTC);
};

export const readRefreshTokenExpiresAtUTC = (): string | null => localStorage.getItem(REFRESH_TOKEN_EXPIRES_AT_KEY);

export const deleteRefreshTokenExpiresAtUTC = (): void => {
    localStorage.removeItem(REFRESH_TOKEN_EXPIRES_AT_KEY);
};

export const persistToken = (token: string): void => {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
};

export const readToken = (): string => {
    return localStorage.getItem(ACCESS_TOKEN_KEY) || '';
};

export const persistRefreshToken = (token: string): void => {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
};

export const readRefreshToken = (): string => {
    return localStorage.getItem(REFRESH_TOKEN_KEY) || '';
};

export const deleteToken = (): void => localStorage.removeItem(ACCESS_TOKEN_KEY);
export const deleteRefreshToken = (): void => localStorage.removeItem(REFRESH_TOKEN_KEY);
export const deleteAccessAndRefreshTokens = (): void => {
    deleteToken();
    deleteRefreshToken();
    deleteRefreshTokenExpiresAtUTC();
};

export const persistLockUserData = (time: string, email?: string): void => {
    localStorage.setItem('lockUserTime', time);
    if (email) {
        localStorage.setItem('lockUserEmail', email);
    }
};
export const readLockUserTime = (): string => {
    return localStorage.getItem('lockUserTime') || '';
};

export const readLockUserEmail = (): string => {
    return localStorage.getItem('lockUserEmail') || '';
};

export const deleteLockUserTime = (): void => {
    localStorage.removeItem('lockUserTime');
    localStorage.removeItem('lockUserEmail');
};

export const persistRegistrationUserEmail = (email: string) => localStorage.setItem(REGISTRATION_USER_EMAIL_KEY, email);

export const getRegistrationUserEmail = () => localStorage.getItem(REGISTRATION_USER_EMAIL_KEY) || '';

export const persistClient = (client: string) => {
    if (client === ROUTES.DEFAULT.MAINTENANCE) return;

    localStorage.setItem(CLIENT_KEY, client);
};

export const getClient = () => localStorage.getItem(CLIENT_KEY) || '';

export const persistPreferredStartPage = (startPage: string) => localStorage.setItem(START_PAGE_PREFERENCE, startPage);

export const getPreferredStartPage = () => localStorage.getItem(START_PAGE_PREFERENCE) || ROUTES.SIDEBAR.LEARNING;

const ADMIN_CENTER_PUBLISHED_STEPS = 'adminCenterPublishedSteps';

export const readAdminCenterPublishedSteps = (): Record<string, boolean> => {
    try {
        const data = localStorage.getItem(ADMIN_CENTER_PUBLISHED_STEPS);

        return data ? JSON.parse(data) : {};
    } catch (e) {
        console.error('Failed to parse admin center published steps:', e);

        return {};
    }
};

export const persistAdminCenterStepAsPublished = (stepName: string): void => {
    const alreadyPublishedSteps = readAdminCenterPublishedSteps() || {};
    alreadyPublishedSteps[stepName] = true;
    localStorage.setItem(ADMIN_CENTER_PUBLISHED_STEPS, JSON.stringify(alreadyPublishedSteps));
};

export const deleteAdminCenterPublishedSteps = (): void => {
    localStorage.removeItem(ADMIN_CENTER_PUBLISHED_STEPS);
};

export const VIDEO_AUDIO_LANGUAGE_KEY = 'videoAudioLangs';

// audio language the user picked in the video player (e.g. "nb")
export const persistVideoAudioLanguage = (language: string): void =>
    localStorage.setItem(VIDEO_AUDIO_LANGUAGE_KEY, language);

export const getVideoAudioLanguage = (): string | null => localStorage.getItem(VIDEO_AUDIO_LANGUAGE_KEY);
